// src/components/__generated__/ApplicationChat_connection.graphql.ts
var node = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateAccountId",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationChat_connection",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "referenceEntityTypeName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "conversationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "referenceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ConversationEvent",
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationUser",
                "kind": "LinkedField",
                "name": "createdByMessagingUser",
                "plural": false,
                "selections": [
                  v1
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ConversationUser",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Application",
            "kind": "LinkedField",
            "name": "application",
            "plural": false,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vacancyName",
                "storageKey": null
              },
              v2,
              {
                "alias": null,
                "args": null,
                "concreteType": "Vacancy",
                "kind": "LinkedField",
                "name": "vacancy",
                "plural": false,
                "selections": [
                  v0,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerLogoUrl",
                    "storageKey": null
                  },
                  v2,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitConversationsForCandidateConnection",
    "abstractKey": null
  };
}();
node.hash = "c9f9f0e20b7ffe5bc5a75d6866288b8e";
var ApplicationChat_connection_graphql_default = node;

// src/components/ApplicationChat.tsx
import { useContext, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { useFragment as useFragment2 } from "react-relay";
import {
  Button,
  EdLink,
  SectionedLayout,
  Tag,
  WithParams
} from "shared-ui";
import { useUserSessionContext } from "app-core";
import { ApplicationConversationContainer } from "feature-recruit";

// src/components/__generated__/GlobalChatQuery.graphql.ts
var node2 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "candidateId",
      "variableName": "candidateId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateAccountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "GlobalChatQuery",
      "selections": [
        {
          "alias": "conversations",
          "args": v1,
          "concreteType": "RecruitConversationsForCandidateConnection",
          "kind": "LinkedField",
          "name": "recruitConversationsForCandidate",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "GlobalChatList_connection"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "GlobalChatQuery",
      "selections": [
        {
          "alias": "conversations",
          "args": v1,
          "concreteType": "RecruitConversationsForCandidateConnection",
          "kind": "LinkedField",
          "name": "recruitConversationsForCandidate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Conversation",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "referenceEntityTypeName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "conversationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "referenceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ConversationEvent",
                  "kind": "LinkedField",
                  "name": "events",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConversationUser",
                      "kind": "LinkedField",
                      "name": "createdByMessagingUser",
                      "plural": false,
                      "selections": [
                        v3,
                        v2
                      ],
                      "storageKey": null
                    },
                    v2
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ConversationUser",
                  "kind": "LinkedField",
                  "name": "users",
                  "plural": true,
                  "selections": [
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    v2
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5c5fd3075639c54b1b9e66d9c25094af",
      "id": null,
      "metadata": {},
      "name": "GlobalChatQuery",
      "operationKind": "query",
      "text": "query GlobalChatQuery(\n  $candidateId: UUID!\n) {\n  conversations: recruitConversationsForCandidate(candidateId: $candidateId) {\n    ...GlobalChatList_connection\n  }\n}\n\nfragment ApplicationChat_connection on RecruitConversationsForCandidateConnection {\n  nodes {\n    id\n    title\n    referenceEntityTypeName\n    conversationId\n    referenceId\n    events {\n      content\n      createdByMessagingUser {\n        candidateAccountId\n        id\n      }\n      id\n    }\n    users {\n      candidateAccountId\n      firstName\n      lastName\n      id\n    }\n    application {\n      id\n      applicationId\n      vacancyName\n      status\n      vacancy {\n        id\n        employerName\n        employerLogoUrl\n        status\n        name\n      }\n    }\n  }\n}\n\nfragment GlobalChatList_connection on RecruitConversationsForCandidateConnection {\n  ...ApplicationChat_connection\n}\n"
    }
  };
}();
node2.hash = "763dc90dc5d810cd7e1d41f2bb83be7e";
var GlobalChatQuery_graphql_default = node2;

// src/components/GlobalChat.tsx
import { createContext, useState } from "react";
import { useLazyLoadQuery } from "react-relay";
import { EdSkeleton } from "shared-ui";

// src/components/__generated__/GlobalChatList_connection.graphql.ts
var node3 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GlobalChatList_connection",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationChat_connection"
    }
  ],
  "type": "RecruitConversationsForCandidateConnection",
  "abstractKey": null
};
node3.hash = "bc877c5fc9e4612d15d63b9888aaf674";
var GlobalChatList_connection_graphql_default = node3;

// src/components/GlobalChatList.tsx
import { useFragment } from "react-relay";
import { useTabs } from "shared-ui";
import { jsx } from "react/jsx-runtime";
var fragmentDef = GlobalChatList_connection_graphql_default;
var GlobalChatList = ({ fragmentRef }) => {
  const data = useFragment(
    fragmentDef,
    fragmentRef
  );
  const [current, tabLinks] = useTabs([
    { name: "Applications" },
    { name: "Finance" }
  ]);
  let currentTab;
  switch (current.name) {
    case "Applications": {
      currentTab = /* @__PURE__ */ jsx("div", { className: "flex-1", children: /* @__PURE__ */ jsx(ApplicationChat, { fragmentRef: data }) });
      break;
    }
    default: {
      currentTab = /* @__PURE__ */ jsx("div", { className: "flex-1", children: "No chats started" });
      break;
    }
  }
  return /* @__PURE__ */ jsx("div", { children: currentTab });
};

// src/components/GlobalChat.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var queryDef = GlobalChatQuery_graphql_default;
var ChatContext = createContext({ showSectionSidebar: true, setShowSectionSidebar: () => true });
var GlobalChat = ({ candidateId }) => {
  const query = useLazyLoadQuery(
    queryDef,
    { candidateId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [showSectionSidebar, setShowSectionSidebar] = useState(true);
  if (!query || !query.conversations) {
    return /* @__PURE__ */ jsx2(EdSkeleton, {});
  }
  return /* @__PURE__ */ jsx2(ChatContext.Provider, { value: { showSectionSidebar, setShowSectionSidebar }, children: /* @__PURE__ */ jsx2(GlobalChatList, { fragmentRef: query.conversations }) });
};

// src/components/ApplicationChat.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var fragmentDef2 = ApplicationChat_connection_graphql_default;
var ApplicationChat = ({ fragmentRef }) => {
  const data = useFragment2(
    fragmentDef2,
    fragmentRef
  );
  const { setShowSectionSidebar } = useContext(ChatContext);
  const session = useUserSessionContext();
  const sections = data?.nodes?.map(({ title, conversationId, application, users }) => ({
    key: conversationId,
    onClick: () => {
      setShowSectionSidebar(false);
    },
    listTitle: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1 p-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center justify-between gap-5 font-bold", children: [
        /* @__PURE__ */ jsx3("div", { className: "line-clamp-1", children: /* @__PURE__ */ jsx3("span", { children: users.filter((x) => x.candidateAccountId !== session.userId).map((user) => `${user.firstName} ${user.lastName}`).join(", ") }) }),
        /* @__PURE__ */ jsxs("div", { className: "text-primary-900 flex gap-1 text-xs", children: [
          /* @__PURE__ */ jsx3("div", { className: "line-clamp-1" }),
          /* @__PURE__ */ jsx3("div", { children: application?.vacancy.employerName })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center justify-between gap-1", children: [
        /* @__PURE__ */ jsx3("span", { className: "line-clamp-2 text-xs text-gray-400", children: title }),
        /* @__PURE__ */ jsx3("div", { className: "flex self-end text-sm text-gray-900", children: /* @__PURE__ */ jsx3(Tag, { size: "xsmall", children: /* @__PURE__ */ jsx3("span", { className: "lowercase", children: application?.vacancy.status }) }) })
      ] })
    ] }),
    itemTitle: /* @__PURE__ */ jsxs("div", { className: "flex grow flex-col flex-col-reverse items-center justify-end lg:flex-row lg:justify-between xl:w-full", children: [
      /* @__PURE__ */ jsx3("div", { className: "flex w-full items-center justify-end gap-2 md:justify-start xl:w-auto xl:flex-row-reverse", children: application?.vacancy?.name && /* @__PURE__ */ jsx3("div", { className: "hidden whitespace-nowrap text-xl font-bold text-gray-800  lg:block lg:block xl:block ", children: application?.vacancy.name }) }),
      /* @__PURE__ */ jsx3("div", { className: "flex w-full  justify-end gap-4", children: application && /* @__PURE__ */ jsx3(
        EdLink,
        {
          name: "view-vacancy",
          href: `/candidates/app/applications/${application.applicationId}/info`,
          children: /* @__PURE__ */ jsx3("div", { className: "flex items-center rounded-2xl border border-gray-400", children: /* @__PURE__ */ jsx3(Button, { color: `white`, children: "Go To\xA0Application" }) })
        }
      ) })
    ] }),
    iconForeground: "text-gray-700",
    iconBackground: "bg-gray-100",
    element: /* @__PURE__ */ jsx3(Suspense, { fallback: "Loading...", children: /* @__PURE__ */ jsx3(
      ApplicationConversationContainer,
      {
        chatId: conversationId,
        showBackButton: false
      }
    ) })
  })) || [];
  return /* @__PURE__ */ jsxs(Routes, { children: [
    /* @__PURE__ */ jsx3(
      Route,
      {
        path: "*",
        element: /* @__PURE__ */ jsx3(
          SectionedLayout,
          {
            expandLink: (id) => `../conversation/${id}`,
            sections,
            title: "Application Chat"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx3(
      Route,
      {
        path: "conversation/:id",
        element: /* @__PURE__ */ jsx3(WithParams, { children: ({ params }) => /* @__PURE__ */ jsx3(
          ApplicationConversationContainer,
          {
            showMobileNavigation: true,
            showExpand: false,
            chatId: params.id,
            showBackButton: false
          }
        ) })
      }
    )
  ] });
};

// src/components/__generated__/RecruitConversations_connectionPaginationQuery.graphql.ts
var node4 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "items": [
        {
          "kind": "Variable",
          "name": "order.0",
          "variableName": "order"
        }
      ],
      "kind": "ListValue",
      "name": "order"
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RecruitConversations_connectionPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            },
            v2,
            {
              "kind": "Variable",
              "name": "order",
              "variableName": "order"
            }
          ],
          "kind": "FragmentSpread",
          "name": "RecruitConversations_connection"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RecruitConversations_connectionPaginationQuery",
      "selections": [
        {
          "alias": "conversations",
          "args": v3,
          "concreteType": "RecruitConversationsConnection",
          "kind": "LinkedField",
          "name": "recruitConversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitConversationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Conversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceEntityTypeName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConversationEvent",
                      "kind": "LinkedField",
                      "name": "events",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "content",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ConversationUser",
                          "kind": "LinkedField",
                          "name": "createdByMessagingUser",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "candidateAccountId",
                              "storageKey": null
                            },
                            v4
                          ],
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Application",
                      "kind": "LinkedField",
                      "name": "application",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vacancyName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "candidate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "firstName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastName",
                              "storageKey": null
                            },
                            v4
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Vacancy",
                          "kind": "LinkedField",
                          "name": "vacancy",
                          "plural": false,
                          "selections": [
                            v4,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "employerName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "employerLogoUrl",
                              "storageKey": null
                            },
                            v5
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "conversations",
          "args": v3,
          "filters": [
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "RecruitConversations_conversations",
          "kind": "LinkedHandle",
          "name": "recruitConversations"
        }
      ]
    },
    "params": {
      "cacheID": "d2873ce04d29b9d09ed53bae8264eab1",
      "id": null,
      "metadata": {},
      "name": "RecruitConversations_connectionPaginationQuery",
      "operationKind": "query",
      "text": "query RecruitConversations_connectionPaginationQuery(\n  $after: String = null\n  $employerId: UUID\n  $first: Int = 10\n  $order: ConversationSort!\n) {\n  ...RecruitConversations_connection_47t8wT\n}\n\nfragment RecruitConversations_connection_47t8wT on Query {\n  conversations: recruitConversations(first: $first, after: $after, where: {employerId: {eq: $employerId}}, order: [$order]) {\n    edges {\n      node {\n        id\n        title\n        referenceEntityTypeName\n        conversationId\n        referenceId\n        events {\n          content\n          createdByMessagingUser {\n            candidateAccountId\n            id\n          }\n          id\n        }\n        application {\n          id\n          applicationId\n          vacancyName\n          code\n          status\n          candidate {\n            firstName\n            lastName\n            id\n          }\n          vacancy {\n            id\n            name\n            employerName\n            employerLogoUrl\n            status\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node4.hash = "94f047c7fc83dd746ea664ebbf6cf41a";
var RecruitConversations_connectionPaginationQuery_graphql_default = node4;

// src/components/__generated__/RecruitConversations_connection.graphql.ts
var node5 = function() {
  var v0 = [
    "conversations"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerId"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "order"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": RecruitConversations_connectionPaginationQuery_graphql_default
      }
    },
    "name": "RecruitConversations_connection",
    "selections": [
      {
        "alias": "conversations",
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "order.0",
                "variableName": "order"
              }
            ],
            "kind": "ListValue",
            "name": "order"
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "eq",
                    "variableName": "employerId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "employerId"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "RecruitConversationsConnection",
        "kind": "LinkedField",
        "name": "__RecruitConversations_conversations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitConversationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referenceEntityTypeName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "conversationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referenceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationEvent",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationUser",
                        "kind": "LinkedField",
                        "name": "createdByMessagingUser",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "candidateAccountId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Application",
                    "kind": "LinkedField",
                    "name": "application",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "applicationId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vacancyName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      v2,
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccountsCandidateAccount",
                        "kind": "LinkedField",
                        "name": "candidate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Vacancy",
                        "kind": "LinkedField",
                        "name": "vacancy",
                        "plural": false,
                        "selections": [
                          v1,
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "employerName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "employerLogoUrl",
                            "storageKey": null
                          },
                          v2
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node5.hash = "94f047c7fc83dd746ea664ebbf6cf41a";
var RecruitConversations_connection_graphql_default = node5;

// src/components/RecruitConversations.tsx
import { useContext as useContext2, Suspense as Suspense2, useState as useState3, useCallback } from "react";
import { Route as Route2, Routes as Routes2 } from "react-router-dom";
import {
  usePaginationFragment,
  usePreloadedQuery
} from "react-relay";
import {
  Button as Button2,
  EdLink as EdLink2,
  SectionedLayout as SectionedLayout2,
  Tag as Tag2,
  WithParams as WithParams2
} from "shared-ui";
import { useUserSessionContext as useUserSessionContext2 } from "app-core";
import { ApplicationConversationContainer as ApplicationConversationContainer2 } from "feature-recruit";

// src/components/__generated__/RecruitConversationsChatQuery.graphql.ts
var node6 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "order.0",
          "variableName": "order"
        }
      ],
      "kind": "ListValue",
      "name": "order"
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RecruitConversationsChatQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            },
            {
              "kind": "Variable",
              "name": "order",
              "variableName": "order"
            }
          ],
          "kind": "FragmentSpread",
          "name": "RecruitConversations_connection"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RecruitConversationsChatQuery",
      "selections": [
        {
          "alias": "conversations",
          "args": v1,
          "concreteType": "RecruitConversationsConnection",
          "kind": "LinkedField",
          "name": "recruitConversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitConversationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Conversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceEntityTypeName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConversationEvent",
                      "kind": "LinkedField",
                      "name": "events",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "content",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ConversationUser",
                          "kind": "LinkedField",
                          "name": "createdByMessagingUser",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "candidateAccountId",
                              "storageKey": null
                            },
                            v2
                          ],
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Application",
                      "kind": "LinkedField",
                      "name": "application",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vacancyName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        v3,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "candidate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "firstName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastName",
                              "storageKey": null
                            },
                            v2
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Vacancy",
                          "kind": "LinkedField",
                          "name": "vacancy",
                          "plural": false,
                          "selections": [
                            v2,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "employerName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "employerLogoUrl",
                              "storageKey": null
                            },
                            v3
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "conversations",
          "args": v1,
          "filters": [
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "RecruitConversations_conversations",
          "kind": "LinkedHandle",
          "name": "recruitConversations"
        }
      ]
    },
    "params": {
      "cacheID": "cd7b65678faa8812885b11850b1c10dc",
      "id": null,
      "metadata": {},
      "name": "RecruitConversationsChatQuery",
      "operationKind": "query",
      "text": "query RecruitConversationsChatQuery(\n  $employerId: UUID!\n  $order: ConversationSort!\n) {\n  ...RecruitConversations_connection_2to7PT\n}\n\nfragment RecruitConversations_connection_2to7PT on Query {\n  conversations: recruitConversations(first: 10, where: {employerId: {eq: $employerId}}, order: [$order]) {\n    edges {\n      node {\n        id\n        title\n        referenceEntityTypeName\n        conversationId\n        referenceId\n        events {\n          content\n          createdByMessagingUser {\n            candidateAccountId\n            id\n          }\n          id\n        }\n        application {\n          id\n          applicationId\n          vacancyName\n          code\n          status\n          candidate {\n            firstName\n            lastName\n            id\n          }\n          vacancy {\n            id\n            name\n            employerName\n            employerLogoUrl\n            status\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "42ba0b7ce0a02dda4eeb4601182fd717";
var RecruitConversationsChatQuery_graphql_default = node6;

// src/components/RecruitConversationsChat.tsx
import { createContext as createContext2, useState as useState2 } from "react";
import { useQueryLoader } from "react-relay";
import { EdSkeleton as EdSkeleton2 } from "shared-ui";
import { jsx as jsx4 } from "react/jsx-runtime";
var RecruitConversationsContext = createContext2({
  showSectionSidebar: true,
  setShowSectionSidebar: () => true,
  loadQuery: () => true
});
function RecruitConversationsChat({
  employerId
}) {
  const [queryReference, loadQuery] = useQueryLoader(
    RecruitConversationsChat.query
  );
  const [showSectionSidebar, setShowSectionSidebar] = useState2(true);
  if (!queryReference) {
    loadQuery({
      employerId,
      order: {
        lastActivity: "DESC"
      }
    });
    return /* @__PURE__ */ jsx4(EdSkeleton2, {});
  }
  return /* @__PURE__ */ jsx4(
    RecruitConversationsContext.Provider,
    {
      value: { showSectionSidebar, setShowSectionSidebar, loadQuery },
      children: /* @__PURE__ */ jsx4(RecruitConversationsContainer, { queryRef: queryReference })
    }
  );
}
RecruitConversationsChat.query = RecruitConversationsChatQuery_graphql_default;

// src/components/RecruitConversations.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
function RecruitConversationsContainer({
  queryRef
}) {
  const fragmentRef = usePreloadedQuery(
    RecruitConversationsChat.query,
    queryRef
  );
  return /* @__PURE__ */ jsx5(RecruitConversations, { fragmentRef });
}
function RecruitConversations({ fragmentRef }) {
  const { data, loadNext, refetch } = usePaginationFragment(RecruitConversations.fragment.connection, fragmentRef);
  const { setShowSectionSidebar } = useContext2(ChatContext);
  const session = useUserSessionContext2();
  const sections = data?.conversations?.edges?.map((x) => x.node).map(({ conversationId, application }) => ({
    key: conversationId,
    onClick: () => {
      setShowSectionSidebar(false);
    },
    listTitle: /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-2 px-4 py-1", children: [
      /* @__PURE__ */ jsx5("div", { className: "flex w-full items-center justify-between gap-5", children: /* @__PURE__ */ jsxs2("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ jsxs2("div", { className: "line-clamp-1", children: [
          application?.candidate.firstName,
          " ",
          application?.candidate.lastName
        ] }),
        /* @__PURE__ */ jsx5("div", { className: "text-xs text-gray-500", children: application?.vacancyName })
      ] }) }),
      /* @__PURE__ */ jsxs2("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ jsx5("span", { className: "line-clamp-2 text-xs text-gray-400", children: application?.vacancy.employerName }),
        /* @__PURE__ */ jsx5("div", { className: "flex self-end text-sm text-gray-900", children: /* @__PURE__ */ jsx5(Tag2, { size: "xsmall", children: /* @__PURE__ */ jsx5("span", { className: "lowercase", children: application?.vacancy.status }) }) })
      ] })
    ] }),
    itemTitle: /* @__PURE__ */ jsxs2("div", { className: "flex grow flex-col flex-col-reverse items-center justify-end justify-end md:flex-row lg:flex-row lg:justify-between xl:w-full", children: [
      /* @__PURE__ */ jsx5("div", { className: "flex w-full items-center justify-end gap-2 md:justify-start xl:w-auto xl:flex-row-reverse", children: /* @__PURE__ */ jsx5("div", { className: "hidden whitespace-nowrap text-xl font-bold text-gray-800  lg:block lg:block xl:block ", children: application?.vacancy.name }) }),
      /* @__PURE__ */ jsx5("div", { className: "flex w-full  justify-end gap-4", children: application && /* @__PURE__ */ jsx5(
        EdLink2,
        {
          name: "view-vacancy",
          href: `/employers/app/applications/application/${application.code}/relevance`,
          children: /* @__PURE__ */ jsx5("div", { className: "flex items-center rounded-2xl border border-gray-400", children: /* @__PURE__ */ jsx5(Button2, { color: `white`, children: "Go To Application" }) })
        }
      ) })
    ] }),
    iconForeground: "text-gray-700",
    iconBackground: "bg-gray-100",
    element: /* @__PURE__ */ jsx5(Suspense2, { fallback: "Loading...", children: /* @__PURE__ */ jsx5(
      ApplicationConversationContainer2,
      {
        chatId: conversationId,
        showBackButton: false
      }
    ) })
  })) || [];
  const sortStates = {
    MOST_RECENT: "Most Recent",
    LEAST_RECENT: "Least Recent",
    DATE_CREATED_ASC: "Date Created Ascending",
    DATE_CREATED_DESC: "Date Created Descending"
  };
  const [sortState, setSortState] = useState3("MOST_RECENT");
  const sortBy = useCallback(
    (state) => {
      let order = {};
      switch (state) {
        case "MOST_RECENT":
          order = {
            lastActivity: "DESC"
          };
          break;
        case "LEAST_RECENT":
          order = {
            lastActivity: "ASC"
          };
          break;
        case "DATE_CREATED_ASC":
          order = {
            createdAt: "ASC"
          };
          break;
        case "DATE_CREATED_DESC":
          order = {
            createdAt: "DESC"
          };
          break;
      }
      refetch({
        order
      });
      setSortState(state);
    },
    [refetch]
  );
  return /* @__PURE__ */ jsxs2(Routes2, { children: [
    /* @__PURE__ */ jsx5(
      Route2,
      {
        path: "*",
        element: /* @__PURE__ */ jsxs2(Fragment, { children: [
          /* @__PURE__ */ jsxs2("div", { className: "xl:flew-row flex flex-col items-start gap-5 border-b bg-white px-4 py-2 md:flex-row  lg:flex-row lg:pb-0", children: [
            /* @__PURE__ */ jsx5("div", { className: "flex-1 py-2 text-2xl font-medium text-gray-700", children: "Application Chats" }),
            /* @__PURE__ */ jsx5("div", { className: "mb-1 w-24 flex-1", children: /* @__PURE__ */ jsx5(
              "select",
              {
                id: "vacancyApplicationSortFields",
                name: "vacancyApplicationSortFields",
                value: sortState,
                className: "focus:ring-primary-500 focus:border-primary-500 block grow rounded-lg border-gray-300 ",
                onChange: (e) => sortBy(e.target.value),
                children: Object.entries(sortStates).map(([key, value]) => /* @__PURE__ */ jsx5("option", { value: key, children: value }, key))
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx5(
            SectionedLayout2,
            {
              expandLink: (id) => `../conversation/${id}`,
              sections,
              loadMore: () => {
                loadNext(15);
              }
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx5(
      Route2,
      {
        path: "conversation/:id",
        element: /* @__PURE__ */ jsx5(WithParams2, { children: ({ params }) => /* @__PURE__ */ jsx5(
          ApplicationConversationContainer2,
          {
            showMobileNavigation: true,
            showExpand: false,
            chatId: params.id,
            showBackButton: false
          }
        ) })
      }
    )
  ] });
}
RecruitConversations.fragment = {
  connection: RecruitConversations_connection_graphql_default
};
export {
  ApplicationChat,
  ChatContext,
  GlobalChat,
  GlobalChatList,
  RecruitConversations,
  RecruitConversationsChat,
  RecruitConversationsContainer,
  RecruitConversationsContext
};
//# sourceMappingURL=index.mjs.map